<template>
  <div>
    <el-form :inline="true" style="margin-top: 20px">
      <el-form-item>
        <el-button size="medium" @click="addPrice">发起比价</el-button>
        <el-button size="medium" @click="gotoConfigPrice" type="primary">比价配置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border stripe
      :default-sort="{ prop: 'START_DAY', order: 'descending' }">
      <el-table-column prop="index" label="序号" width="80" type="index"></el-table-column>
      <el-table-column prop="START_DAY" sortable label="生效日期"></el-table-column>
      <el-table-column prop="END_DAY" label="结束日期"></el-table-column>
      <el-table-column prop="NAME" label="比价类别"></el-table-column>
      <el-table-column prop="STATUS" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.STATUS == 1">提交数据</span>
          <span v-if="scope.row.STATUS == 2">提交给供应商</span>
          <span v-if="scope.row.STATUS == 3">比价完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="inputData(scope.row)">发布报价</el-button>
          <el-button type="text" size="small" @click="checkSupplier(scope.row)">查看供应商</el-button>
          <el-button type="text" size="small" @click="exportTable(scope.row)">导出</el-button>
          <el-button v-preventReClick type="text" size="small" @click="deadline(scope.row)">截止时间</el-button>
          <el-button type="text" size="small" v-if="scope.row.STATUS != 3" @click="finishPrice(scope.row)">比价完成并更新报价
          </el-button>
          <el-button type="text" size="small" v-if="scope.row.STATUS != 3" @click="finishPrice2(scope.row)">比价完成
          </el-button>

          <el-button v-preventReClick type="text" size="small" @click="supplierPurchaseOrder(scope.row)"
            :disabled="scope.row.STATUS !== 3">一键生成采购订单</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增比价列表" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item label="比价包名称：" :label-width="formLableWidth">
          <el-select filterable v-model="addForm.subClassList" multiple placeholder="请选择">
            <el-option v-for="item in classList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效日期：" :label-width="formLableWidth">
          <el-date-picker v-model="addForm.startDate" align="right" type="date" :picker-options="pickerOptions1"
            placeholder="请选择生效日期" value-format="yyyy-MM-dd" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期：" :label-width="formLableWidth">
          <el-date-picker v-model="addForm.endDate" align="right" type="date" placeholder="请选择结束日期"
            value-format="yyyy-MM-dd" style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 生成采购订单 -->
    <el-dialog :visible.sync="supplierPurchaseOrderDialog" @close="supplierPurchaseOrderDialog = false" title="生成采购订单"
      width="800px" center>
      <el-form ref="orderForm" v-model="orderForm" :inline="true">
        <el-form-item label="配送日期：" :label-width="formLableWidth">
          <el-date-picker v-model="orderForm.SEND_DAY" align="right" type="date" :picker-options="pickerOptions1"
            placeholder="请选择配送日期" value-format="yyyy-MM-dd" style="width: 100%">
          </el-date-picker>
          <label style="
              display: block;
              margin-left: -82px;
              margin-top: 10px;
              margin-bottom: -15px;
            ">低价供应商：</label>
        </el-form-item>
        <el-table :data="supplierList" style="width: 100%" border stripe>
          <el-table-column label="序号" width="80" type="index"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称"></el-table-column>
          <el-table-column prop="FEE" label="预计采购总金额"></el-table-column>
          <el-table-column prop="action" label="操作">
            <!--  prop="" -->
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="submitPurchaseOrder(scope.row)">立即转换</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
    <el-dialog title="设置截止日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <el-form v-model="editDateForm" :ref="editDateForm">
        <el-form-item label="选择截止日期：">
          <el-date-picker v-model="editDateForm.DEADLINE_TIME" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="subDate">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination_box" v-show="total_count > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';
// import date from '@/assets/common/date';

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      fileList: [],
      formLableWidth: '100px',
      addForm: {},
      orderForm: {
      },
      supplierPurchaseOrderDialog: false,
      addDialog: false,
      total_count: 0,
      pageSize: 10,
      currentPage: 1,
      // 大类列表
      subClassList: [],
      classList: [],
      // 报价的供应商列表
      supplierList: [],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      COMPARE_ID: 0,
      editDateForm: {
        DEADLINE_TIME: '',
      },
      DateVisible: false,
      endTime: '',
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.editDateForm = this.SAVE_DSORDER_LIST.DEADLINE_TIME;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    if (sessionStorage.getItem('currentPage') > 1) {
      this.currentPage = Number(sessionStorage.getItem('currentPage'));
    }
    this.getPriceList();
  },
  methods: {
    // 获取比价列表
    getPriceList() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 1,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.total_count = 0;
        } else {
          this.tableData = res[0].list;
          this.total_count = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getPriceList();
    },
    // 点击新增
    addPrice() {
      this.addDialog = true;
      sessionStorage.setItem('currentPage', this.currentPage);
      this.getClassInfo();
    },
    // 获取大类名称
    getClassInfo() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 12,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无大类数据', type: 'warning' });
        } else {
          this.classList = res;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增比价记录
    submitAddPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 22,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.addForm.subClassList) {
        params.F_CAT_ID_LISTS = this.addForm.subClassList;
      }
      if (this.addForm.startDate) {
        params.START_DAY = this.addForm.startDate;
      } else {
        this.$message.show({ text: '请选择生效时间', type: 'warning' });
        return false;
      }
      if (this.addForm.endDate) {
        params.END_DAY = this.addForm.endDate;
      } else {
        this.$message.show({ text: '请选择结束时间', type: 'warning' });
        return false;
      }
      console.log(this.addForm.subClassList);
      if (this.addForm.subClassList == '') {
        this.$message.show({ text: '请选择大类名称', type: 'warning' });
        return false;
      } if (this.addForm.subClassList == null) {
        this.$message.show({ text: '请选择大类名称', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.subClassList = [];
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 点击录入数据
    inputData(row) {
      this.$router.push({ path: `/inputData/${row.COMPARE_ID}/${row.STATUS}`, params: { id: row.COMPARE_ID, status: row.STATUS } });
      sessionStorage.setItem('currentPage', this.currentPage);
    },
    // 导出
    exportTable(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 28,
        COMPARE_ID: row.COMPARE_ID,
      };
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据，供应商未报价', type: 'warning' });
        } else {
          window.location.href = res[0].FILE_PATH;
          this.$message.show({ text: '导出成功', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 比价完成并更新
    finishPrice(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 27,
        COMPARE_ID: row.COMPARE_ID,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 比价完成
    finishPrice2(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 270,
        COMPARE_ID: row.COMPARE_ID,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查看供应商比价列表
    checkSupplier(row) {
      this.$router.push({ path: `/supplierDetail/${row.COMPARE_ID}/${row.STATUS}`, params: { id: row.COMPARE_ID, status: row.STATUS } });
      sessionStorage.setItem('COMPARE_ID', row.COMPARE_ID);
      sessionStorage.setItem('currentPage', this.currentPage);
    },
    // 一键生成采购订单弹框
    supplierPurchaseOrder(row) { ///
      this.supplierPurchaseOrderDialog = true;
      // 获取供应商
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 29,
        COMPARE_ID: row.COMPARE_ID,
      };
      http.post(params).then((result) => {
        this.supplierList = result;
        console.log(this.supplierList);
      })
        .catch((error) => {
          console.log(error);
        });
      this.COMPARE_ID = row.COMPARE_ID;
    },

    // 一键生成采购订单
    submitPurchaseOrder(row) { ///
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 30,
        COMPARE_ID: this.COMPARE_ID,
        SUPPLIER_ID: row.SUPPLIER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.orderForm.SEND_DAY,

      };
      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.supplierPurchaseOrderDialog = false;
        this.getPriceList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 设置截止时间
    deadline(row) {
      this.DateVisible = true;
      sessionStorage.setItem('COMPARE_ID', row.COMPARE_ID);
      this.getEndTime();
    },
    closeDate() {
      this.DateVisible = false;
      this.editDateForm.DEADLINE_TIME = '';
      // this.editDateForm = {};
    },
    // 获取截止时间
    getEndTime() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 35,
        COMPARE_ID: Number(sessionStorage.getItem('COMPARE_ID')),
      };
      http.post(params).then((result) => {
        const time = result[0].DEADLINE_TIME;
        if (time != 0) {
          const strTime = `${(time.toString()).slice(0, 4)}-${(time.toString()).slice(4, 6)}-${(time.toString()).slice(6, 8)}`;
          this.endTime = new Date(strTime);
          this.editDateForm.DEADLINE_TIME = this.endTime;
          console.log(this.endTime, '截止时间转时间类型');
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改日期
    subDate() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 34,
        COMPARE_ID: Number(sessionStorage.getItem('COMPARE_ID')),
      };
      if (this.editDateForm.DEADLINE_TIME) {
        params.DEADLINE_TIME = Number(this.editDateForm.DEADLINE_TIME.split('-').join(''));
      } else {
        this.$message.show({ text: '请选择截止日期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        if (result.length === 0) {
          this.$message.show({ text: '没有找到比价记录', type: 'warning' });
        } else {
          this.$message.show({ text: result, type: 'success' });
          this.DateVisible = false;
          // this.editDateForm = {};
          this.editDateForm.DEADLINE_TIME = '';
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoConfigPrice() {
      this.$router.push({ path: '/configPrice' });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/comparePrice.vue